define(['lodash',
    'coreUtils',
    'prop-types',
    'santaProps/utils/propsSelectorsUtils'
],
function (_,
          coreUtils,
          PropTypes,
          propsSelectorsUtils) {
    'use strict';

    const createGlobalSantaType = propsSelectorsUtils.createGlobalSantaType;

    const userLanguage = createGlobalSantaType(PropTypes.string, function (state) {
        return coreUtils.wixUserApi.getLanguageFromSiteData(state.siteData);
    }, 'userLanguage');

    return {
        userLanguage
    };
});
